document.addEventListener("turbolinks:load", function(event) {
    var url = event.data.url;

    dataLayer.push({
    'event':'pageView',
    'virtualUrl': url
    });

});
